module.exports = __webpack_public_path__ + "img/south-sudan.b79b37ee.png";